<template>
    <a :href="'signatures/' + envelope.id"
        class="py-4 px-5 border-b border-x border-gray-200 flex items-center justify-between hover:bg-gray-warm-100 transition-colors"
    >
        <div class="text-md font-semibold">
            <div class="leading-snug">
                {{ envelope.title }}
            </div>

            <div class="text-xs text-gray-500 font-normal">
                {{ envelope.docusign_documents.length }} {{ envelope.docusign_documents.length === 1 ? 'document' : 'documents' }} with {{ envelope.recipients.length }} {{ envelope.recipients.length === 1 ? 'signer' : 'signers' }}
            </div>
        </div>

        <div class="flex items-center">
            <div v-if="fetching"
                class="mr-3"
            >
                <i class="text-green-warm-500 text-sm fas fa-spin fa-sync" aria-hidden="true" />
            </div>

            <div class="text-sm">
                <div v-if="envelope_completed_at"
                    class="text-blue-600"
                >
                    Completed on <span class="font-bold">{{ completed_at_date_formatted_date }}</span>
                    at <span class="font-bold">{{ completed_at_date_formatted_time }}</span>
                </div>

                <div v-else-if="envelope_sent_at"
                    class="text-green-warm-600"
                >
                    Sent on <span class="font-bold">{{ sent_at_date_formatted_date }}</span>
                    at <span class="font-bold">{{ sent_at_date_formatted_time }}</span>
                </div>

                <div v-else
                    class="text-gray-500"
                >
                    Unsent
                </div>
            </div>
        </div>
    </a>
</template>

<script>
export default {
    props: {
        envelope: {},
    },

    data() {
        return {
            fetching: false,
            envelope_status: this.envelope.status,
            envelope_sent_at: this.envelope.sent_at,
            envelope_completed_at: this.envelope.completed_at,
        }
    },

    computed: {
        sent_at_date_formatted_date() {
            return this.envelope_sent_at ? dayjs(this.envelope_sent_at).format('M/D/YYYY') : null;
        },
        sent_at_date_formatted_time() {
            return this.envelope_sent_at ? dayjs(this.envelope_sent_at).format('h:mm A') : null;
        },
        completed_at_date_formatted_date() {
            return this.envelope_completed_at ? dayjs(this.envelope_completed_at).format('M/D/YYYY') : null;
        },
        completed_at_date_formatted_time() {
            return this.envelope_completed_at ? dayjs(this.envelope_completed_at).format('h:mm A') : null;
        },
    },

    methods: {
        getEnvelopeStatus() {
            this.fetching = true;

            axios.get(this.envelope.status_route)
                .then(response => {
                    this.envelope_status = response.data.status;
                    this.envelope_sent_at = response.data.sent_at;
                    this.envelope_completed_at = response.data.completed_at;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(error => {
                    this.fetching = false;
                });
        },
    },

    created() {
        if (this.envelope.sent_at && ! this.envelope.completed_at) {
            this.getEnvelopeStatus();
        }
    },
}
</script>
